import { empApi } from "./client";
import { EMP_WEBSITE_CODE } from "../config";

// Lấy cấu hình chấm công (bán kính, địa điểm mặc định...) -> { value }
export const getSettingApi = (name) =>
  empApi.get("/employee/app/settings", { websiteCode: EMP_WEBSITE_CODE, name });

// ============ Chấm công (check-in flow) ============
// Luồng: startCheckin -> verifyCheckinPlace(GPS) -> (verifyImage/QR/BSSID) -> completeCheckin

export const startCheckinApi = (checkinDevice) =>
  empApi.post("/checkin/startCheckin", checkinDevice ? { checkinDevice } : {});

export const getCheckinPlacesApi = (params = { page: 1, limit: 100, status: true }) =>
  empApi.get("/checkin/place/list", params);

export const verifyCheckinPlaceApi = ({ location, checkinPlaceId }) =>
  empApi.post("/checkin/verifyCheckinPlace", { location, checkinPlaceId });

export const verifyCheckinImageApi = (checkinImage) =>
  empApi.post("/checkin/verifyImage", { checkinImage });

export const verifyCheckinQrCodeApi = (checkinCode) =>
  empApi.post("/checkin/verifyQrCode", { checkinCode });

export const verifyCheckinBssidApi = (bssId) =>
  empApi.post("/checkin/verifyBssid", { bssId });

export const completeCheckinApi = () => empApi.post("/checkin/completeCheckin", {});

// ============ Upload ảnh (dùng cho verifyImage / minh chứng) ============
export const uploadImageApi = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return empApi.upload("/common/upload/image", fd); // -> { filePath }
};

// Đồng bộ ảnh từ URL về hệ thống (khớp app v2: /common/upload/image-url)
export const uploadImageByLinkApi = (url) =>
  empApi.post("/common/upload/image-url", { url: (url || "").trim() });

// ============ Trạng thái / lịch chuyên cần ============
export const getCheckinEligibilityApi = (date) =>
  empApi.get("/employee/app/getCheckinEligibility", date ? { date } : undefined);

// date dạng mm-yyyy
export const getAttendanceCalendarByMonthApi = (date) =>
  empApi.get("/employee/app/getMyAttendanceCalendarByMonth", date ? { date } : undefined);

// date dạng mm-yyyy, attendanceType: ALL | MISSING | <type>
export const getAttendanceSummaryByMonthApi = (date, attendanceType = "ALL") =>
  empApi.get("/employee/app/getMyAttendanceSummaryByMonth", {
    ...(date ? { date } : {}),
    attendanceType,
  });

export const getAttendanceDetailByDayApi = (date) =>
  empApi.get("/employee/app/getMyAttendanceDetailByDay", date ? { date } : undefined);
